<template>
  <div :class="['bg_radial_lb', 'lg:py-20 py-10']">
    <CommonBanner
      :title="t('page.index.question.title')"
      :desc="t('page.index.question.desc')"
      box-class="py-10"
      separator-class="bg-secondary"
    />
    <Motion
      :initial="{ opacity: 0, y: 120 }"
      :while-in-view="{ opacity: 1, y: 0 }"
      :transition="{
        type: 'spring',
        stiffness: 20,
        damping: 10,
      }"
      :in-view-options="{
        once: true,
      }"
      :class="['page_view']"
    >
      <UAccordion :items="accordionItems" />
    </Motion>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n()

  /** 常见问题列表 */
  const accordionItems = ref([
    {
      icon: 'mdi:question-mark-circle-outline',
      label: t('page.index.question.content[0].q'),
      content: t('page.index.question.content[0].a'),
    },
    {
      icon: 'mdi:question-mark-circle-outline',
      label: t('page.index.question.content[1].q'),
      content: t('page.index.question.content[1].a'),
    },
    {
      icon: 'mdi:question-mark-circle-outline',
      label: t('page.index.question.content[2].q'),
      content: t('page.index.question.content[2].a'),
    },
    {
      icon: 'mdi:question-mark-circle-outline',
      label: t('page.index.question.content[3].q'),
      content: t('page.index.question.content[3].a'),
    },
    {
      icon: 'mdi:question-mark-circle-outline',
      label: t('page.index.question.content[4].q'),
      content: t('page.index.question.content[4].a'),
    },
  ])
</script>
